import _regeneratorRuntime from '@babel/runtime/helpers/esm/regeneratorRuntime';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';

/**
 * @typedef AuthorizerV3Params
 * @type {object}
 * @property {boolean} isLive - Indicates if the content is live.
 * @property {string} contentId - The content ID.
 * @property {() => number} [getDelay] - A function to get the delay.
 * @property {() => boolean} [getIsMobileNetwork] - A function to check if it's a mobile network.
 */

/**
 * Get version 3 authorizer object.
 *
 * @param {Object} backendService - The backend service instance.
 * @param {AuthorizerV3Params} params - The playback info parameters object.
 * @returns {import("./getAuthHeadersGetter").Authorizer} - The authorizer object.
 */
function getV3Authorizer(backendService, /* params: */_ref) {
  var isLive = _ref.isLive,
    contentId = _ref.contentId,
    getDelay = _ref.getDelay,
    getIsMobileNetwork = _ref.getIsMobileNetwork;
  return {
    getToken: function () {
      var _getToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _yield$backendService, _yield$backendService2, accessToken, refreshToken;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return backendService.entitlement.v3.getTokenAuthorizer({
                delay: (getDelay === null || getDelay === void 0 ? void 0 : getDelay()) || 0,
                mobileNetwork: (getIsMobileNetwork === null || getIsMobileNetwork === void 0 ? void 0 : getIsMobileNetwork()) || false,
                isLive: isLive,
                contentId: contentId
              });
            case 2:
              _yield$backendService = _context.sent;
              _yield$backendService2 = _yield$backendService.data;
              accessToken = _yield$backendService2.authorization;
              refreshToken = _yield$backendService2.refreshToken;
              return _context.abrupt("return", {
                data: {
                  accessToken: accessToken,
                  refreshToken: refreshToken
                }
              });
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function getToken() {
        return _getToken.apply(this, arguments);
      }
      return getToken;
    }(),
    refreshToken: function refreshToken( /* authHeadersData: */_ref2) {
      var _refreshToken = _ref2.refreshToken;
      return backendService.entitlement.v3.refreshTokenAuthorizer({
        delay: (getDelay === null || getDelay === void 0 ? void 0 : getDelay()) || 0,
        mobileNetwork: (getIsMobileNetwork === null || getIsMobileNetwork === void 0 ? void 0 : getIsMobileNetwork()) || false,
        refreshToken: _refreshToken
      });
    }
  };
}

export { getV3Authorizer };
//# sourceMappingURL=authorizer.js.map
